import { Autocomplete, Box, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Task } from "../../interface";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';

const TaskForm = ({ task, listForConfig, onChange }: { task: Task | undefined, listForConfig: any, onChange: any }) => {
    return (
        <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={listForConfig?.proyectos?.find((element: any) => element.id === task?.projectId)?.label || ""}
                        options={listForConfig?.proyectos || []}
                        onChange={(event: any, newValue: any) => onChange(newValue?.id, "projectId")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Proyecto"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={12}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={listForConfig?.tipo?.find((element: any) => element.id === task?.type)?.label || ""}
                        options={listForConfig?.tipo||[]}
                        onChange={(event: any, newValue: any) => onChange(newValue?.id, "type")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Tipo"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={12}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={listForConfig?.status?.find((element: any) => element.id === task?.status)?.label || ""}
                        options={listForConfig?.status||[]}
                        onChange={(event: any, newValue: any) => onChange(newValue?.id, "status")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Estado"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={12}>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        size="small"
                        value={listForConfig?.tecnologia?.find((element: any) => element.id === task?.tecnology)?.label || ""}
                        options={listForConfig?.tecnologia||[]}
                        onChange={(event: any, newValue: any) => onChange(newValue?.id, "tecnology")}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Tecnologia"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid size={4}>
                    <TextField
                        id="cuadrilla"
                        label="Cuadrilla"
                        value={`${task?.cuadrillaNumber || "0"}`}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(Number(value))) {
                                onChange(value, "cuadrillaNumber");
                            }
                        }}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid size={4}>
                    <TextField
                        id="groupAssigned"
                        label="groupAssigned"
                        value={`${task?.groupAssigned || "0"}`}
                        onChange={() => {}}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid size={4}>
                    <TextField
                        id="Meta"
                        label="Meta"
                        value={`${task?.target || "0"}`}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(Number(value))) {
                                onChange(value, "target");
                            }
                        }}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid size={6}>
                    <DatePicker
                        label="Fecha Inicio"
                        value={task?.startDate ? moment(task.startDate) : null}
                        onChange={(newValue) => onChange(newValue, "startDate")}
                        sx={{ width: "100%" }}
                    />
                </Grid>
                <Grid size={6}>
                    <DatePicker
                        label="Fecha culminacion"
                        value={task?.planningEndDate ? moment(task.planningEndDate) : null}
                        onChange={(newValue) => onChange(newValue, "planningEndDate")}
                        sx={{ width: "100%" }}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Descripción"
                        multiline
                        rows={4}
                        value={task?.description || ""}
                        onChange={(event) => onChange(event.target.value, "description")}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default TaskForm;
